import subjects from "./subjects.json";
import deliveryOrInstallation from "./deliveryOrInstallation.json";
import installationIssueGasOrWaterLeak from "./deliveryOrInstallation/installationIssueGasOrWaterLeak.json";
import damageToProperty from "./deliveryOrInstallation/damageToProperty.json";
import standardDeliveryIssue from "./deliveryOrInstallation/standardDeliveryIssue.json";
import installationIssueStandard from "./deliveryOrInstallation/installationIssueStandard.json";
import returnsAndRefunds from "./returnsAndRefunds.json";
import returns from "./returnsAndRefunds/returns.json";
import refunds from "./returnsAndRefunds/refunds.json";
import addedCareWarrantyGuarantee from "./returnsAndRefunds/addedCareWarrantyGuarantee.json";
import faultyProducts from "./faultyProducts.json";
import faultyProductsDamageToProperty from "./faultyProducts/damageToProperty.json";
import infestation from "./faultyProducts/infestation.json";
import electricalProducts from "./faultyProducts/electricalProducts.json";
import allFurniture from "./faultyProducts/allFurniture.json";
import nurseryTravelProduct from "./faultyProducts/nurseryTravelProduct.json";
import allOtherProducts from "./faultyProducts/allOtherProducts.json";
import personalInjury from "./personalInjury.json";
import policyOrService from "./policyOrService.json";
import serviceComplaint from "./policyOrService/serviceComplaint.json";
import branch from "./policyOrService/branch.json";
import dataPrivacy from "./policyOrService/dataPrivacy.json";
import nku from "./policyOrService/nku.json";
import policy from "./policyOrService/policy.json";
import onlineAndWebsite from "./onlineAndWebsite.json";
import onlineAccountIssues from "./onlineAndWebsite/onlineAccountIssues.json";
import productOrWebsiteInfo from "./onlineAndWebsite/productOrWebsiteInfo.json";
import johnLewisFinancialProducts from "./johnLewisFinancialProducts.json";
import banking from "./johnLewisFinancialProducts/banking.json";
import partnershipCard from "./johnLewisFinancialProducts/partnershipCard.json";
import insurance from "./johnLewisFinancialProducts/insurance.json";
import investmentsAndLoans from "./johnLewisFinancialProducts/investmentsAndLoans.json";
import pointOfSaleCredit from "./johnLewisFinancialProducts/pointOfSaleCredit.json";
import foreignExchange from "./johnLewisFinancialProducts/foreignExchange.json";
import fittedKitchensAndBathrooms from "./fittedKitchensAndBathrooms.json";
import fittedKitchens from "./fittedKitchensAndBathrooms/fittedKitchens.json";
import fittedBathrooms from "./fittedKitchensAndBathrooms/fittedBathrooms.json";
import windowsAndFlooring from "./windowsAndFlooring.json";
import windowsCoverings from "./windowsAndFlooring/windowsCoverings.json";
import floorCoverings from "./windowsAndFlooring/floorCoverings.json";
import windows from "./windows.json";
import issueWithOrder from "./issueWithOrder.json";
import orderEnquiryOrDelayedOrder from "./issueWithOrder/orderEnquiryOrDelayedOrder.json";
import orderFailureOrCancelledOrder from "./issueWithOrder/orderFailureOrCancelledOrder.json";
import { cloneDeep } from "lodash";

export const escalateComplaintsData = (isHideFlooringsActive = false) => {
  const modifiedSubjectsOptions = subjects.select.options.map(opt =>
    opt.value === "windowsAndFlooring"
      ? {
          value: "windows",
          label: "Windows",
        }
      : opt
  );
  const modifiedSubjects = cloneDeep(subjects)
  modifiedSubjects.select.options = modifiedSubjectsOptions;
  return {
  subjects: isHideFlooringsActive ? modifiedSubjects : subjects,
  deliveryOrInstallation,
  installationIssueGasOrWaterLeak,
  damageToProperty,
  standardDeliveryIssue,
  installationIssueStandard,

  returnsAndRefunds,
  returns,
  refunds,
  addedCareWarrantyGuarantee,

  faultyProducts,
  faultyProductsDamageToProperty,
  infestation,
  electricalProducts,
  allFurniture,
  nurseryTravelProduct,
  allOtherProducts,

  personalInjury,

  policyOrService,
  serviceComplaint,
  branch,
  dataPrivacy,
  nku,
  policy,

  onlineAndWebsite,
  onlineAccountIssues,
  productOrWebsiteInfo,

  johnLewisFinancialProducts,
  banking,
  partnershipCard,
  insurance,
  investmentsAndLoans,
  pointOfSaleCredit,
  foreignExchange,

  fittedKitchensAndBathrooms,
  fittedKitchens,
  fittedBathrooms,

  windowsAndFlooring,
  windowsCoverings,
  floorCoverings,
  windows,

  issueWithOrder,
  orderEnquiryOrDelayedOrder,
  orderFailureOrCancelledOrder
}
};
